import { TypedDocumentNode, gql } from '@apollo/client';

import { availableBalancesFragment } from 'contexts/currentUser/queries';
import { useQuery } from 'hooks/graphql/useQuery';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

import type {
  GetCurrentUserWithdrawal,
  GetCurrentUserWithdrawalVariables,
} from './__generated__/useBankWithdrawal.graphql';

const GET_CURRENT_USER_WITHDRAWAL_QUERY = gql`
  query GetCurrentUserWithdrawal {
    currentUser {
      slug
      availableBalanceForWithdrawal
      bankBalance
      bankMappedEthereumAddress
      ethMigration {
        id
      }
      ...CurrentUserProvider_availableBalances
    }
  }
  ${availableBalancesFragment}
` as TypedDocumentNode<
  GetCurrentUserWithdrawal,
  GetCurrentUserWithdrawalVariables
>;

export const useBankWithdrawal = () => {
  const {
    flags: { useBaseBank = false },
  } = useFeatureFlags();
  const { data, loading } = useQuery(GET_CURRENT_USER_WITHDRAWAL_QUERY);

  if (!data?.currentUser) return { loading };

  const { currentUser } = data;
  const {
    availableBalanceForWithdrawal,
    bankBalance,
    availableBalances,
    ethMigration,
    bankMappedEthereumAddress,
  } = currentUser;

  const availableBalance = availableBalances?.wei?.wei || 0n;

  return {
    withdrawableAmount:
      availableBalanceForWithdrawal < bankBalance
        ? availableBalanceForWithdrawal
        : bankBalance,
    availableBalanceForWithdrawal,
    availableBalance,
    bankBalance,
    ethMigration,
    isFastWithdrawal: (!!ethMigration || bankBalance === 0n) && !useBaseBank,
    isBaseWithdrawal: useBaseBank,
    bankMappedEthereumAddress,
    loading,
  };
};
